import React, { Component } from 'react'
import { connect } from 'react-redux'
import connectCommon from '../common/common-hoc';
import * as actionCreator from '../../redux/actions/data-action';

import history from '../../routes/history';

import { TaskRadioGroupButtons, TaskDialog } from './common/task-controls';

import { 
    AssessmentContainer, 
    AssessmentBody, 
    AssessmentContent, 
    AssessmentNavigationPrevious, 
    AssessmentNavigationNext, 
    AssessmentFooter
} from './common';
import { getTasks, TaskType, SubTaskType, getOutcomes } from './common/task-utility';

const outcomeLink = "/Assessment/Outcome/Items";
const previousLink = "/Assessment/Outcome/Instruction";
const nextLink = "/PostAdmin/ConcernsStrengths";
const itemsPerPage = 1;

class AssessmentOutcomeItems extends Component {
    constructor(props) {
        super(props);

        this.state = { showWarningMessage: false }

        this.onChange = this.onChange.bind(this);
        this.handleClickNext = this.handleClickNext.bind(this);
        this.handleClickPrevious = this.handleClickPrevious.bind(this);
        this.handleCloseWarning = this.handleCloseWarning.bind(this);
    }

    onChange(e) {
        const { setOutcomeResponse } = this.props;
        const { name, value } = e.target;
        
        let id = 0;

        if (isNaN(name) === false) {
            id = parseInt(name);
        }

        setOutcomeResponse(id, value);
        this.forceUpdate();
        this.handleClickNext();
    }

    canGoNext(items) {
      for(let i = 0; i < items.length; i++)
      {
        if (parseInt(items[i].response[0]) === -9999) {
          return false
        }
      }

        return true;
      }

    hasReponse(task) {
      return task && task.response && task.response.length > 0 && task.response[0] !== -9999;
    }

    handleClickNext() {
        const { items, saveData } = this.props;
        
        const currentIndex = this.getCurrentIndex();

        var min = currentIndex * itemsPerPage;
        var max = min + (itemsPerPage - 1);

        let itemsOnPage = [];

        for (let i = min; i <= max; i++) {
          itemsOnPage.push(items[i]);
        }

        if(this.canGoNext(itemsOnPage)) {
          this.goNext();
        } else {
          this.setState({ showWarningMessage: true })
        }
    }  

    goNext() {
      const { items, saveData, saveScreenDuration } = this.props;
        
      const currentIndex = this.getCurrentIndex();

      if ((currentIndex * itemsPerPage) + 1 < items.length - (itemsPerPage - 1)) {
        //saveData();
        saveScreenDuration();
        history.push(`${outcomeLink}/${currentIndex + 2}`);

      } else {
          saveData();
          history.push(nextLink);
      }
    }

    handleCloseWarning() {
      this.setState({ showWarningMessage: false });
    }

    handleForceNext() {
      this.setState({ showWarningMessage: false });

      this.goNext();
    }

    handleClickPrevious() {
        const { saveData } = this.props;

         const currentIndex = this.getCurrentIndex();

        if (currentIndex > 0) {
            saveData();
            history.push(`${outcomeLink}/${currentIndex}`);
        } else {
            history.push(previousLink);
        }
    }

    getCurrentIndex() {
        const { match } = this.props;
        const index = match.params.index;

        if (index) {
            return parseInt(index - 1);
        }

        return 0;
    }

    render() {
        const { items } = this.props;

        if (items === undefined || items.length === 0) {
            return null;
        }
        const currentIndex = this.getCurrentIndex()
        const label = currentIndex + 1 + ' OF ' + Math.ceil(items.length / itemsPerPage);

        var components = [];

        for(let i = 0; i < items.length; i++) {
          components.push(
            <TaskRadioGroupButtons
              key={i} 
              name={items[i].id.toString()}
              label={items[i].question}
              value={items[i].response && items[i].response[0]}
              data={items[i].options}
              textField="label"
              dataItemKey="value"
              inline={true}
              onChange={this.onChange} 
              onClick={this.handleClickNext} />
          )
        }

        const questions = components.map(component => component).filter(component => {
          var min = currentIndex * itemsPerPage;
          var max = min + (itemsPerPage - 1);

          return parseInt(component.key) >= min && parseInt(component.key) <= max; 
        })

        return (
          <>
            <TaskDialog visible={this.state.showWarningMessage} onClose={this.handleCloseWarning} onNext={() => this.handleForceNext()} header={this.getTaskDialogHeaderText}>
                You did not answer {itemsPerPage > 1 ? 'a' : 'this'} question.<br /><br />Please provide a response. If you want to leave the question blank, click on the "Next" button to continue to the next screen.
            </TaskDialog>
            <AssessmentContainer> 
                <AssessmentBody>
                    <AssessmentNavigationPrevious onClick={this.handleClickPrevious} />
                    <AssessmentContent>
                        {questions}
                    </AssessmentContent>
                    <AssessmentNavigationNext onClick={this.handleClickNext} />
                </AssessmentBody>
                <AssessmentFooter label={label} copyrightChild={"©2009 Robins, Fein, & Barton"}></AssessmentFooter>
            </AssessmentContainer>
          </>
        )
    }
}


const mapStateToProps = (state, ownState) => ({
    items : state.data.outcomes,
})

export default connect(mapStateToProps, Object.assign({}, actionCreator))(connectCommon(AssessmentOutcomeItems))